<template>
  <div>
    <b-form-group
      id="input-group-3"
      label="Motivo de anulación:"
      label-for="input-3"
    >
      <b-form-select
        id="input-3"
        v-model="motiveSelected"
        :options="optionMotives"
        required
      >
        <b-form-select-option :value="null"
          >Seleccione una opción
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-row>
      <b-col cols="12">
        <b-form-checkbox
          id="checkbox-1"
          v-model="status"
          name="checkbox-1"
          value="accepted"
          unchecked-value="not_accepted"
          @change="resetValue"
        >
          Se realizará pago a proveedor
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row v-if="status == 'accepted'">
      <b-col cols="12">
        <label for="range-1">Monto</label>
        <b-form-input
          v-model="amount"
          type="number"
          placeholder="Ingrese el monto"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-bottom">
        <label>Observaciones</label>
        <b-form-textarea
          v-model="observation"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="text-medium padding-two-bottom"
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-center">
        <b-button :disabled="isEnablebBtn" @click="anularOS" class="bg-purple">
          <font-awesome-icon icon="trash" /> Anular
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "ConfirmarOs",
  props: ["detailId","beetrackRouteId","identityDocument"],
  data() {
    return {
      amount: null,
      status: "",
      form: { observation: "" },
      observation: "",
      motiveSelected: null,
      optionMotives: [],
      valuesResponseAnular: { show: true, message: "", hasError: false },
    };
  },
  created() {
    this.listMotives();
  },
  computed: {
    ...mapState("module", ["username"]),
    isEnablebBtn(){
      if(this.status=='accepted'&&this.amount){
        return false
      }
      if(this.status==''){
        return false
      }
      return false
    }
  },
  methods: {
    resetValue(){
      if(this.status=='not_accepted'){
        this.amount=null;
      }
    },
    listMotives() {
      if (this.optionMotives.length == 0) {
        axios
          .get(
            process.env.VUE_APP_ORDERS_CORE_BASE +
              "/motives?limit=20&page=1&pagination=true&type=ANNULMENT"
          )
          .then((response) => {
            let filterData=response.data.filter(c=>c.id!=113)
            const data = filterData.map((row) => {
              return {
                value: row.id,
                text: row.description,
              };
            });
            
            this.optionMotives = data;
          })
          .catch((error) => console.log(error));
      }
    },
    async anularOneTrack() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.put(
          process.env.VUE_APP_BASE_ONETRACK + "/route/"+this.beetrackRouteId,
          {
            state: 4,
            userModification: this.username,
            subState: this.motiveSelected,
            "dutyManager": "ENCARGADO",
            clientDni: this.identityDocument,
            clientName: "",
            origin:"TIENDA"
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response)
        
      this.valuesResponseAnular.message = "Anulación exitosa";
      } catch (error) {
        console.log(error);
        this.valuesResponseAnular.hasError = true;
        this.valuesResponseAnular.message = error.response.data.message;
      } finally {
        this.$bvModal.hide("modal-anular");
        this.$emit("setResponse", this.valuesResponseAnular);
        this.$store.commit("SET_LOADING", false);
      }
    },
    async anularOS(){
      this.anularOSManual();
      /*if(this.beetrackRouteId){
         await this.anularOneTrack();
        } else{
          this.anularOSManual();
        } */
    },
    async anularOSManual() {
      try {
        
        let amountCancel=this.amount?this.amount:0
        let payment = this.status == "accepted" ? "1" : "0";
        this.$store.commit("SET_LOADING", true);
        let response = await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/annulments",
          {
            motive: this.motiveSelected,
            childId: this.detailId,
            user: this.username,
            observation: this.observation,
            cancellationAmount: parseInt(amountCancel),
            paymentProvider: payment,
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        
        this.valuesResponseAnular.message = "Anulación exitosa";
      } catch (error) {
        console.log(error);
        this.valuesResponseAnular.hasError = true;
        this.valuesResponseAnular.message = error.response.data.message;
      } finally {
        this.$bvModal.hide("modal-anular");
        this.$emit("setResponse", this.valuesResponseAnular);
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>
<style scoped>
</style>
